import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
export const useCart = () => useContext(CartCtx);

const read = (k, fallback) => {
  try {
    return JSON.parse(localStorage.getItem(k)) ?? fallback;
  } catch {
    return fallback;
  }
};

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => read("pc_cart", []));
  const [goals, setGoals] = useState(() => read("pc_goals", { calories: 2200, protein: 120 }));
  const [favorites, setFavorites] = useState(() => read("pc_favorites", []));
  const [open, setOpen] = useState(false);

  useEffect(() => localStorage.setItem("pc_cart", JSON.stringify(items)), [items]);
  useEffect(() => localStorage.setItem("pc_goals", JSON.stringify(goals)), [goals]);
  useEffect(() => localStorage.setItem("pc_favorites", JSON.stringify(favorites)), [favorites]);

  const add = (it) => {
    setItems((prev) => {
      const ex = prev.find((p) => p.key === it.key);
      if (ex) return prev.map((p) => (p.key === it.key ? { ...p, qty: p.qty + 1 } : p));
      return [...prev, { ...it, qty: 1 }];
    });
    setOpen(true);
  };
  const remove = (key) => setItems((prev) => prev.filter((p) => p.key !== key));
  const setQty = (key, q) =>
    setItems((prev) => (q <= 0 ? prev.filter((p) => p.key !== key) : prev.map((p) => (p.key === key ? { ...p, qty: q } : p))));
  const clear = () => setItems([]);

  const saveFavorite = (label) => {
    if (!items.length) return null;
    const totalQty = items.reduce((s, i) => s + i.qty, 0);
    const fav = {
      id: `fav_${Date.now()}`,
      label: (label && label.trim()) || `My Combo · ${totalQty} item${totalQty > 1 ? "s" : ""}`,
      items: items.map(({ key, name, price, calories, protein, addons, qty }) => ({ key, name, price, calories, protein, addons: addons || [], qty })),
      created_at: new Date().toISOString(),
    };
    setFavorites((f) => [fav, ...f]);
    return fav;
  };
  const removeFavorite = (id) => setFavorites((f) => f.filter((x) => x.id !== id));
  const reorderFavorite = (id) => {
    const fav = favorites.find((x) => x.id === id);
    if (!fav) return;
    setItems((prev) => {
      const map = new Map(prev.map((p) => [p.key, { ...p }]));
      fav.items.forEach((it) => {
        const ex = map.get(it.key);
        if (ex) ex.qty += it.qty;
        else map.set(it.key, { ...it });
      });
      return Array.from(map.values());
    });
    setOpen(true);
  };

  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
  const totalCalories = items.reduce((s, i) => s + (i.calories || 0) * i.qty, 0);
  const totalProtein = items.reduce((s, i) => s + (i.protein || 0) * i.qty, 0);

  return (
    <CartCtx.Provider
      value={{ items, add, remove, setQty, clear, count, subtotal, totalCalories, totalProtein, goals, setGoals, open, setOpen, favorites, saveFavorite, removeFavorite, reorderFavorite }}
    >
      {children}
    </CartCtx.Provider>
  );
}
